import { PDP_MEDIA_PREVIEW_CLICK } from 'features/product-info/components/pdp-media-gallery/actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType, createAction } from 'typesafe-actions';
import { selectProductPriceCategory } from 'features/product-info';
import { NOT_SET } from '../utils';
import { selectProductBelong, selectProductId, selectProductName, selectProductPrice } from './selectors';
import { GaProductBelong } from './types';

/**
 * Cобытие должно срабатывать при клике на любое превью товара (фото, видео или любой иной тип медиаконтента)
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaClickMediaPreview = createAction('GA:clickButton')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: string; // тип контента из Media Repository
  mediaLink: string; // ссылка на видео/картинку

  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productBelong: GaProductBelong; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productTag: string; // bestPrice для “Лучшей цены” и onlineOnly для “Только онлайн заказ”, а также остальные бейджи. При наличии нескольких передавать через разделитель “,”
}>();

export function* putGaClickMediaPreview(mediaType?: string, contentLink?: string) {
  const elementName = mediaType ?? NOT_SET;
  const mediaLink = contentLink ?? NOT_SET;

  yield put(
    gaClickMediaPreview({
      elementType: 'button',
      elementBlock: 'productDetail',
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productTag: yield call(selectProductPriceCategory),
      elementName,
      mediaLink,
    }),
  );
}

export function* runClickMediaPreviewDetector() {
  yield takeEvery(
    PDP_MEDIA_PREVIEW_CLICK,
    function* handle({ payload }: ActionType<typeof PDP_MEDIA_PREVIEW_CLICK>) {
      const { mediaType, contentLink } = payload;
      yield putGaClickMediaPreview(mediaType, contentLink);
    },
  );
}
